var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcActiveSchoolManage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_176_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7C2 3.68629 4.68629 1 8 1H36C39.3137 1 42 3.68629 42 7V35C42 38.3137 39.3137 41 36 41H8C4.68629 41 2 38.3137 2 35V7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5H36C39.0376 1.5 41.5 3.96243 41.5 7V35C41.5 38.0376 39.0376 40.5 36 40.5H8C4.96243 40.5 2.5 38.0376 2.5 35V7C2.5 3.96243 4.96243 1.5 8 1.5Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_743)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3103 11.149L24.7243 10.3797L25.3103 9.61053C25.4376 9.44363 25.4055 9.20515 25.2386 9.07786C25.1721 9.0272 25.0908 8.99982 25.0073 9.00001H22.0073C21.7957 8.99882 21.6226 9.16805 21.619 9.37958V12.7619H22.3809V11.7619H25.0073C25.2181 11.7614 25.3887 11.5901 25.3882 11.3792C25.388 11.2961 25.3606 11.2152 25.3103 11.149Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2791 21C12.9688 20.9984 12.7159 21.2486 12.7142 21.5589C12.7142 21.5614 12.7142 21.5639 12.7142 21.5663V29H17.5238V21H13.2791ZM14.5238 26.9048C14.5238 27.1152 14.3532 27.2857 14.1428 27.2857C13.9324 27.2857 13.7619 27.1152 13.7619 26.9048V26.0862C13.7619 25.8758 13.9324 25.7052 14.1428 25.7052C14.3532 25.7052 14.5238 25.8758 14.5238 26.0862V26.9048ZM14.5238 23.7163C14.5238 23.9267 14.3532 24.0972 14.1428 24.0972C13.9324 24.0972 13.7619 23.9267 13.7619 23.7163V22.8976C13.7619 22.6872 13.9324 22.5167 14.1428 22.5167C14.3532 22.5167 14.5238 22.6872 14.5238 22.8976V23.7163ZM16.4761 26.9048C16.4761 27.1152 16.3056 27.2857 16.0952 27.2857C15.8848 27.2857 15.7142 27.1152 15.7142 26.9048V26.0862C15.7142 25.8758 15.8848 25.7052 16.0952 25.7052C16.3056 25.7052 16.4761 25.8758 16.4761 26.0862V26.9048ZM16.4761 23.7163C16.4761 23.9267 16.3056 24.0972 16.0952 24.0972C15.8848 24.0972 15.7142 23.9267 15.7142 23.7163V22.8976C15.7142 22.6872 15.8848 22.5167 16.0952 22.5167C16.3056 22.5167 16.4761 22.6872 16.4761 22.8976V23.7163Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9388 15.6904L18.2858 18.7978V29H19.9524V25.0328C19.9474 24.8356 20.1031 24.6717 20.3003 24.6666C20.3068 24.6664 20.3132 24.6664 20.3196 24.6666H23.5943C23.7874 24.6618 23.9479 24.8143 23.9527 25.0074C23.9529 25.0159 23.9529 25.0243 23.9524 25.0328V29H25.5715V18.7942L21.9388 15.6904ZM23.5943 22.5238H20.2981C20.0877 22.5238 19.9171 22.3532 19.9171 22.1428C19.9171 21.9324 20.0877 21.7619 20.2981 21.7619H23.5943C23.8047 21.7619 23.9752 21.9324 23.9752 22.1428C23.9752 22.3532 23.8047 22.5238 23.5943 22.5238Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7283 21C30.7259 21 30.7234 21 30.7209 21H26.3334V29H31.2858V21.5663C31.2882 21.256 31.0386 21.0025 30.7283 21ZM28.2858 26.9048C28.2858 27.1151 28.1152 27.2857 27.9048 27.2857C27.6944 27.2857 27.5239 27.1151 27.5239 26.9048V26.0861C27.5239 25.8758 27.6944 25.7052 27.9048 25.7052C28.1152 25.7052 28.2858 25.8758 28.2858 26.0861V26.9048ZM28.2858 23.7163C28.2858 23.9267 28.1152 24.0972 27.9048 24.0972C27.6944 24.0972 27.5239 23.9267 27.5239 23.7163V22.8976C27.5239 22.6872 27.6944 22.5167 27.9048 22.5167C28.1152 22.5167 28.2858 22.6872 28.2858 22.8976V23.7163ZM30.1905 26.9048C30.1905 27.1151 30.0199 27.2857 29.8096 27.2857C29.5992 27.2857 29.4286 27.1151 29.4286 26.9048V26.0861C29.4286 25.8758 29.5992 25.7052 29.8096 25.7052C30.0199 25.7052 30.1905 25.8758 30.1905 26.0861V26.9048ZM30.1905 23.7163C30.1905 23.9267 30.0199 24.0972 29.8096 24.0972C29.5992 24.0972 29.4286 23.9267 29.4286 23.7163V22.8976C29.4286 22.6872 29.5992 22.5167 29.8096 22.5167C30.0199 22.5167 30.1905 22.6872 30.1905 22.8976V23.7163Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9572 13.2783L16.5056 17.9455L17.1946 18.7471L21.7099 14.8997C21.8525 14.7782 22.0623 14.7784 22.2047 14.9003L26.7012 18.7487L27.4059 17.9433L21.9572 13.2783Z",
    fill: "#092E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1904 25.4287H20.7142V29.0001H23.1904V25.4287Z",
    fill: "#092E5E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_176_743",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_176_743"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_176_743",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActiveSchoolManage);
export default __webpack_public_path__ + "static/media/ic_active_school_manage.69e5b54c2b500a10fac351c3a030864d.svg";
export { ForwardRef as ReactComponent };